import { useState, useRef, useEffect } from 'react';
import { ttsEventEmitter } from '@/utils/utilsTTS/handler';
import RtcClient from '@/libTTS/RtcClient';
import { StreamIndex } from '@volcengine/rtc';
import { agentSessionUpsertTTS, ttsUpdateSession } from '@/api/grt/ai';
import { getUserId } from '@/utils/Page';
import { Storage } from '@/utils/Storage';
import { uploadFileWithMD5 } from '@/components/Upload/aiTTS';
import { agentFileBucketName, getAgentFileDirName } from '@/utils/Page/constant';
import { v4 as uuidv4 } from 'uuid';
import { toJS } from 'mobx';
const useTTSHandler = (props) => {
    const { store } = props;
    const { sessionStore, chatStore, voiceCallStore } = store;
    const { currentSessionMapId, originMsgMap, setSessionList, sessionList, setSessionMap, sessionMap, originSessionList } = sessionStore;

    const { handleMessages, formatSessionList, isInAnswer, setIsInAnswer, changeSessionMapItem, agentId } = chatStore;
    const { isNewSession, setIsNewSession, setHideTTSActions } = voiceCallStore;

    const [isInVoiceCall, setIsInVoiceCall] = useState(false);
    const ttsMessagesRef = useRef([]); // 保存所有TTS消息
    const ttsContentRef = useRef([]); // 专门保存TTS内容的新变量
    const [TTSNewlist, setTTSNewlist] = useState([]);
    const TTSNewMsg = useRef([]);
    const textBuffer = useRef({});
    const latestRoundIdRef = useRef(null);
    const latestTimestampRef = useRef(null);
    const curMsgIdRef = useRef(null); // 修复：使用useRef保存消息ID，确保流式更新时ID一致

    // 将Base64格式的截图上传到OSS
    const uploadSnapshotToOSS = async (base64Data) => {
        return new Promise(async (resolve, reject) => {
            try {
                // 将Base64数据转换为Blob对象
                const base64WithoutPrefix = base64Data.replace(/^data:image\/\w+;base64,/, '');
                const byteCharacters = atob(base64WithoutPrefix);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += 512) {
                    const slice = byteCharacters.slice(offset, offset + 512);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: 'image/png' });

                // 创建File对象
                const fileName = `snapshot_${Date.now()}.png`;
                const file = new File([blob], fileName, { type: 'image/png' });
                // 定义上传完成的回调函数
                const ossUploadCompleteFunc = (obsResult, file) => {
                    console.log('上传完成，结果:', obsResult);
                    resolve(obsResult);
                    return obsResult;
                };
                // 定义上传失败的回调函数
                const ossErrorFunc = (error, file, obsResult) => {
                    console.error('上传失败:', error, obsResult);
                    reject(new Error('上传失败'));
                };

                // 定义上传进度回调函数
                const ossProcessFunc = (processNumber, file, xhr, obsResult) => {
                    console.log(`上传进度: ${Math.round(processNumber * 100)}%`);
                };

                try {
                    await uploadFileWithMD5({
                        dirname: getAgentFileDirName(),
                        file, // 文件对象
                        fileExt: 'png', // 文件扩展名
                        ossBucketName: agentFileBucketName.oss,
                        ossProcessFunc, // 上传进度回调
                        ossErrorFunc, // 上传失败回调
                        ossUploadCompleteFunc // 上传完成回调
                    });
                } catch (uploadError) {
                    console.error('调用上传函数时出错:', uploadError);
                    reject(uploadError);
                }
            } catch (error) {
                console.error('上传过程中发生错误:', error);
                reject(error);
            }
        });
    };

    // 处理TTS消息
    const handleTTSMessage = async (data) => {
        // console.group('处理TTS消息');
        // console.log(data, 'tts消息');
        // console.groupEnd();
        const { originMsgMap } = sessionStore;
        const { text, user, role, definite, paragraph, roundId, timestamp } = data;
        // 处理文本拼接逻辑
        let finalText = text;
        // 根据TTS的role映射到聊天系统的role
        let chatRole = 'local';
        let chatReply;
        let chatmessage;
        let copyContent;
        if (role === 'assistant') {
            chatRole = 'assistant';
            chatReply = String(timestamp);
            chatmessage = 'answer';
        } else if (role === 'local') {
            chatRole = 'local';
            chatReply = '0';
            chatmessage = 'question';
        }

        const currentSessionId = currentSessionMapId;
        const messages = originMsgMap[currentSessionId]?.messages || [];
        console.log('当前会话messages========当前会话messages========', messages, 'currentSessionId', currentSessionId);
        latestRoundIdRef.current = roundId;
        latestTimestampRef.current = timestamp;

        // 查找最近一条用户消息的 _id
        const getLastUserMessageId = () => {
            const userMsg = messages
                .slice()
                .reverse()
                .find((m) => m.role === 'user' || m.role === 'local');
            return userMsg?._id || getuuid();
        };
        const replyId = role === 'assistant' ? getLastUserMessageId() : '0';

        // 构造缓冲区键值
        const bufferKey = `${currentSessionId}_${roundId}`;

        if (definite === true && paragraph === false) {
            // definite为true但paragraph为false，表示这是中间的文本片段，需要拼接
            if (!textBuffer.current[bufferKey]) {
                textBuffer.current[bufferKey] = '';
            }
            textBuffer.current[bufferKey] += text;
            finalText = textBuffer.current[bufferKey];
        } else if (definite === false && paragraph === false) {
            if (!textBuffer.current[bufferKey]) {
                textBuffer.current[bufferKey] = '';
            }
            finalText = textBuffer.current[bufferKey] + text;
        } else if (definite === true && paragraph === true) {
            // definite和paragraph都为true，表示AI回答完毕，使用拼接后的完整文本
            if (textBuffer.current[bufferKey]) {
                finalText = textBuffer.current[bufferKey] + text;
                // 清除已使用的缓冲区
                delete textBuffer.current[bufferKey];
            }
        }

        console.log('finalTextall=======', finalText);
        // 只有当是用户(local)的提问时，才更新会话名称

        if (role === 'local' && text && definite === true && paragraph === true) {
            let curList = originSessionList ? originSessionList : [];

            // 检查是否已存在相同 session_id 的会话，如果有则更新，否则添加新会话
            const existingSessionIndex = curList.findIndex((session) => session.session_id === currentSessionMapId);
            console.log('existingSessionIndex', existingSessionIndex);
            let updatedList;
            // 确保只有在新会话时（即历史消息列表为空），才更新会话名称
            // 修复：增加额外的判断条件，避免语音通话中误更新会话名称
            if (existingSessionIndex >= 0 && isNewSession === true && currentSessionMapId) {
                // 使用拼接后的完整文本作为会话名称
                let sessionName = finalText;
                const bufferKey = `${currentSessionMapId}_${roundId}`;
                if (textBuffer.current[bufferKey]) {
                    sessionName = textBuffer.current[bufferKey] + text;
                }

                // 修复：只在真正的新会话中更新名称，而不是每次isNewSession为true时都更新
                // 获取当前会话的消息数量，只有消息很少的情况下才允许更新会话名称
                const currentSessionMessages = originMsgMap[currentSessionMapId]?.messages || [];
                // 修改判断条件，检查是否存在用户消息，而不仅仅是消息总数
                const userMessages = currentSessionMessages.filter((msg) => msg.role === 'local');
                const isActuallyNewSession = userMessages.length <= 1; // 只有当用户消息不超过1条时才允许更新会话名称

                if (isActuallyNewSession) {
                    // 更新现有会话的名称
                    const updatedSession = {
                        ...curList[existingSessionIndex],
                        session_name: sessionName
                    };
                    updatedList = [...curList];
                    updatedList[existingSessionIndex] = updatedSession;
                    setSessionList(updatedList);

                    formatSessionList(updatedList);
                    if (isNewSession) {
                        ttsUpdateSession({
                            user_id: getUserId(),
                            session_id: currentSessionMapId,
                            question: finalText
                        }).then((res) => {
                            console.log('接口调用成功，会话保存成功', res);
                        });
                        setIsNewSession(false);
                    }
                }
            }
        }

        // 创建文件信息对象，用于展示截图
        let fileJson = null;
        if (role === 'local' && text) {
            // 检查是否有截图数据
            let snapshotBase64 = null;
            if (RtcClient) {
                snapshotBase64 = await RtcClient.getSnapshotAsBase64(StreamIndex.STREAM_INDEX_MAIN);
            }

            if (snapshotBase64 && definite === true && paragraph === true) {
                const imageUrl = await uploadSnapshotToOSS(snapshotBase64);
                fileJson = [
                    {
                        type: 4,
                        bucket: imageUrl.bucketName,
                        ext_type: imageUrl.ext,
                        object_id: imageUrl.objectKey,
                        file_url: imageUrl.fileUrl,
                        fingerprint: imageUrl.md5
                    }
                ];
            }
        }
        // 修复：为同一轮次的消息使用相同的ID（基于roundId和role）
        const msgKey = `${currentSessionId}_${roundId}_${role}`;
        if (!curMsgIdRef.current || !curMsgIdRef.current[msgKey]) {
            if (!curMsgIdRef.current) {
                curMsgIdRef.current = {};
            }
            curMsgIdRef.current[msgKey] = getuuid();
        }
        const curMsgId = curMsgIdRef.current[msgKey];

        // 创建新的消息对象
        const ttsMessage = {
            agent_id: agentId,
            content: finalText,
            file_json: fileJson,
            content_type: 'text',
            answerContent: finalText,
            question: '',
            create_time: new Date().toLocaleString('zh-CN', { hour12: false }).replace(/\//g, '-'),
            deleted: 0,
            handler: 'general',
            message_type: chatmessage,
            metadata_json: {},
            plugin_json: {
                voice_call: true
            },
            reply_id: replyId,
            role: chatRole,
            section_id: String(roundId),
            session_id: currentSessionMapId,
            skill_id: '-1',
            status: 'complete', // 修复：流式更新时状态为loading
            tenant_id: Storage.get('tenantId'),
            temId: 'tts_' + Date.now(),
            update_time: new Date().toLocaleString('zh-CN', { hour12: false }).replace(/\//g, '-'),
            user_id: getUserId(),
            msg_id: curMsgId,
            _id: curMsgId,
            is_snapshot: true
        };
        if (role === 'local' && definite && paragraph) {
            // 保存用户问题文本到临时存储中，供AI回答时使用
            window.latestUserQuestion = finalText;
        }
        console.log('AI回答时的用户问题:', window.latestUserQuestion);
        if (role === 'assistant') {
            ttsMessage.question = window.latestUserQuestion || '';
        }
        // 只有当definite和paragraph都为true时才添加消息到ttsMessagesRef.current
        if (definite && paragraph) {
            ttsMessagesRef.current = [...ttsMessagesRef.current, ttsMessage];
            ttsContentRef.current = [...ttsContentRef.current, ttsMessage];
            // 清除该轮次的消息ID，为下一轮对话做准备
            const msgKey = `${currentSessionId}_${roundId}_${role}`;
            if (curMsgIdRef.current && curMsgIdRef.current[msgKey]) {
                delete curMsgIdRef.current[msgKey];
            }
        }
        // 更新消息列表（包括流式更新）
        handleTTSMessageUpdate(ttsMessage);
    };

    // 处理AI状态变化
    const handleAIStatusChange = (data) => {
        const { status } = data;
        // 根据状态更新界面
        switch (status) {
            case 'listening':
                setIsInAnswer(true);

                // 当AI开始监听时，捕获当前视频流截图并发送到对话区域
                // captureAndSendSnapshot();
                break;
            case 'thinking':
                // 更新思考状态
                changeSessionMapItem(currentSessionMapId, { loading: true });
                break;
            case 'speaking':
                // AI正在说话
                setIsInAnswer(true);
                break;
            case 'finished':
                // AI说话完成
                changeSessionMapItem(currentSessionMapId, { loading: false });
                setIsInAnswer(true);
                break;
            case 'interrupted':
                // AI被打断
                changeSessionMapItem(currentSessionMapId, { loading: false });
                setIsInAnswer(false);
                break;
        }
    };
    // 更新TTS消息
    const handleTTSMessageUpdate = (ttsMessage) => {
        const { originMsgMap } = sessionStore;
        // 获取当前会话ID
        const sessionId = currentSessionMapId || 'tts_session';

        // 获取当前消息列表
        let oldMessages = originMsgMap[sessionId]?.messages || [];

        if (!ttsMessage.msg_id || !ttsMessage._id) {
            console.warn('无效消息：msg_id 或 _id 为 null，跳过处理:', ttsMessage);
            return false;
        }

        // 修复：使用更准确的查找逻辑，基于msg_id、_id和section_id匹配
        const findMsgIndex = (list, msg) =>
            list.findIndex(
                (ele) => ele.msg_id === msg.msg_id && ele._id === msg._id && ele.section_id === msg.section_id && ele.role === msg.role // 添加role匹配，确保用户和AI消息不会混淆
            );

        let curMsgIndex = findMsgIndex(oldMessages, ttsMessage);

        const newMsgList = [...oldMessages]; // 创建副本避免直接修改原数组
        console.log(newMsgList, 'newMsgListnewMsgList', ttsMessage);
        if (curMsgIndex !== -1) {
            console.log('更新消息:', newMsgList[curMsgIndex]);
            // 更新现有消息（流式更新时合并内容）
            newMsgList[curMsgIndex] = {
                ...newMsgList[curMsgIndex],
                ...ttsMessage,
                // 确保content字段正确更新
                content: ttsMessage.content,
                answerContent: ttsMessage.answerContent || ttsMessage.content,
                status: ttsMessage.status
            };
        } else {
            console.log('添加消息:', ttsMessage);
            console.log(newMsgList, 'newMsgListnewMsgList');
            // 添加新消息
            newMsgList.push(ttsMessage);
        }

        // 修复：同步更新TTSNewMsg，确保消息列表一致
        // 先更新ttsContentRef（如果消息已完成）
        if (ttsMessage.status === 'complete') {
            let ttsContentIndex = findMsgIndex(ttsContentRef.current, ttsMessage);
            if (ttsContentIndex !== -1) {
                ttsContentRef.current[ttsContentIndex] = ttsMessage;
            } else {
                ttsContentRef.current.push(ttsMessage);
            }
        }

        // 更新TTSNewMsg用于显示
        TTSNewMsg.current = [...newMsgList];

        console.log('TTSNewMsg.current', TTSNewMsg.current);

        // 处理消息用于显示
        let webres = handleMessages(newMsgList);
        let newwebres = handleMessages(TTSNewMsg.current);
        setTTSNewlist(newwebres);

        // 修复：根据消息状态设置loading状态
        const isLoading = ttsMessage.status === 'loading';

        changeSessionMapItem(sessionId, { loading: isLoading, messages: webres }, newMsgList);
        return false;
    };

    // 重置消息ID状态
    const resetMessageIdState = () => {
        if (curMsgIdRef.current) {
            curMsgIdRef.current = {};
        }
    };

    // 重置语音通话状态
    const resetVoiceCallStatus = () => {
        // 重置回答状态

        setIsInAnswer(false);
        // 重置sessionMap中的loading状态
        if (currentSessionMapId && sessionMap[currentSessionMapId]) {
            sessionMap[currentSessionMapId].loading = false;
            setSessionMap({ ...sessionMap });
        }
        // 清空TTS消息列表
        if (ttsMessagesRef.current) {
            ttsMessagesRef.current = [];
        }
        if (ttsContentRef.current) {
            ttsContentRef.current = [];
        }
        if (TTSNewMsg.current) {
            TTSNewMsg.current = [];
        }
        // 清空消息ID缓存
        if (curMsgIdRef.current) {
            curMsgIdRef.current = {};
        }
        // 清空文本缓冲区
        textBuffer.current = {};
        setTTSNewlist([]);
    };
    // 添加TTS事件监听
    useEffect(() => {
        // 监听TTS事件
        ttsEventEmitter.on('ttsMessage', handleTTSMessage);
        ttsEventEmitter.on('aiStatusChange', handleAIStatusChange);

        // 清理事件监听
        return () => {
            ttsEventEmitter.off('ttsMessage', handleTTSMessage);
            ttsEventEmitter.off('aiStatusChange', handleAIStatusChange);
        };
    }, [
        // 注意：ref对象不需要在依赖项中，因为它们不会改变
        // 但函数需要包含，因为它们可能会改变
        handleMessages,
        changeSessionMapItem,
        formatSessionList,
        isNewSession,
        setHideTTSActions,
        isInAnswer,
        agentId,
        setSessionMap,
        setIsInVoiceCall
        // 其他ref和常量不需要在依赖项中
    ]);

    // 处理语音通话状态变化
    useEffect(() => {
        const handleVoiceCallStatusChange = (event) => {
            const { inVoiceCall } = event.detail;
            setIsInVoiceCall(inVoiceCall);
            // 当语音通话结束时，立即显示操作按钮
            if (!inVoiceCall) {
                const currentSessionId = currentSessionMapId;
                const currentRoundId = latestRoundIdRef.current;

                if (currentSessionId && currentRoundId) {
                    const bufferKey = `${currentSessionId}_${currentRoundId}`;
                    delete textBuffer.current[bufferKey]; // 清除该轮次的缓冲
                }
            }
        };

        window.addEventListener('voiceCallStatusChange', handleVoiceCallStatusChange);

        return () => {
            window.removeEventListener('voiceCallStatusChange', handleVoiceCallStatusChange);
        };
    }, []);

    const getuuid = () => {
        return uuidv4();
    };

    return {
        ttsMessagesRef,
        ttsContentRef,
        TTSNewMsg,
        TTSNewlist,
        setTTSNewlist,
        resetVoiceCallStatus,
        resetMessageIdState,
        handleTTSMessage,
        handleAIStatusChange,
        handleTTSMessageUpdate,
        uploadSnapshotToOSS,
        isInVoiceCall
    };
};

export default useTTSHandler;
